import { useEffect, useRef } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import CookieBanner from "./components/CookieBanner";
import Footer from "./components/Footer";
import Header from "./components/Header";
import ArticlePage from "./pages/ArticlePage";
import DetailPage from "./pages/DetailPage";
import EditorialPage from "./pages/EditorialPage";
import HomePage from "./pages/HomePage";
import CookiePolicyPage from "./pages/CookiePolicyPage";
import LegalPage from "./pages/LegalPage";
import NotFoundPage from "./pages/NotFoundPage";
import OverviewPage from "./pages/OverviewPage";
import SitemapPage from "./pages/SitemapPage";
import UtilityPage from "./pages/UtilityPage";

function ScrollToTop() {
  const { pathname, hash } = useLocation();
  const isInitialRender = useRef(true);

  useEffect(() => {
    const shouldMoveFocus = !isInitialRender.current;
    isInitialRender.current = false;

    if (hash) {
      const frame = window.requestAnimationFrame(() => {
        document.getElementById(hash.slice(1))?.scrollIntoView({ behavior: "smooth", block: "start" });
      });
      return () => window.cancelAnimationFrame(frame);
    }

    window.scrollTo({ top: 0, behavior: "instant" });
    if (!shouldMoveFocus) return undefined;

    const frame = window.requestAnimationFrame(() => {
      document.getElementById("main-content")?.focus({ preventScroll: true });
    });
    return () => window.cancelAnimationFrame(frame);
  }, [pathname, hash]);
  return null;
}

export default function App() {
  return (
    <>
      <ScrollToTop />
      <Header />
      <main id="main-content" tabIndex="-1">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/science" element={<OverviewPage groupKey="science" />} />
          <Route path="/platform" element={<OverviewPage groupKey="platform" />} />
          <Route path="/applications" element={<OverviewPage groupKey="applications" />} />
          <Route path="/product-line" element={<OverviewPage groupKey="product-line" />} />
          <Route path="/pipeline" element={<OverviewPage groupKey="pipeline" />} />
          <Route path="/insights" element={<UtilityPage pageKey="insights" />} />
          <Route path="/insights/articles" element={<EditorialPage pageKey="insights-articles" />} />
          <Route path="/insights/articles/:slug" element={<ArticlePage />} />
          <Route path="/insights/resources" element={<EditorialPage pageKey="insights-resources" />} />
          <Route path="/insights/events" element={<EditorialPage pageKey="insights-events" />} />
          <Route path="/about" element={<UtilityPage pageKey="about" />} />
          <Route path="/about/leadership" element={<EditorialPage pageKey="about-leadership" />} />
          <Route path="/about/story" element={<EditorialPage pageKey="about-story" />} />
          <Route path="/careers" element={<UtilityPage pageKey="careers" />} />
          <Route path="/investors" element={<UtilityPage pageKey="investors" />} />
          <Route path="/partnership" element={<UtilityPage pageKey="partnership" />} />
          <Route path="/contact" element={<UtilityPage pageKey="contact" />} />
          <Route path="/sitemap" element={<SitemapPage />} />
          <Route path="/:group/:slug" element={<DetailPage />} />
          <Route path="/privacy-policy" element={<LegalPage title="Privacy Policy" />} />
          <Route path="/terms-of-use" element={<LegalPage title="Terms of Use" />} />
          <Route path="/cookie-policy" element={<CookiePolicyPage />} />
          <Route path="/not-found" element={<NotFoundPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </main>
      <Footer />
      <CookieBanner />
    </>
  );
}
